import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  defaultTableWithInputConfigFormModel,
  tableWithInputFieldGetConfigurationConfig,
  tableWithInputFieldParseIntoSettingsFormModel,
  tableWithInputFieldUpdateFromSettingsFormModel,
} from '../table-with-input-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomTableWithInputFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultTableWithInputConfigFormModel;
    this.settingsFormlyForm = tableWithInputFieldGetConfigurationConfig(
      this.formBuilderService
    ).settings.formlyForm;
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return tableWithInputFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return tableWithInputFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
